/**
 * Main App Component
 *
 * Sets up:
 * - AuthProvider for authentication state
 * - AppProvider for global application state
 * - ToastProvider for notifications
 * - React Router for navigation
 * - Protected routes with Layout
 * - Admin routes
 */
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, AppProvider, ToastProvider } from './contexts';
import { ProtectedRoute, AdminRoute } from './components/auth';
import { Layout } from './components/layout';
import { SignInPage, ReportsPage, AdminPage } from './pages';

function App() {
  return (
    <AuthProvider>
      <AppProvider>
        <ToastProvider>
          <Router>
            <Routes>
              {/* Public route - Sign In */}
              <Route path="/signin" element={<SignInPage />} />

              {/* Protected routes with Layout */}
              <Route
                path="/*"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Routes>
                        {/* Default route - Reports */}
                        <Route path="/" element={<ReportsPage />} />

                        {/* Admin routes */}
                        <Route
                          path="/admin/*"
                          element={
                            <AdminRoute>
                              <AdminPage />
                            </AdminRoute>
                          }
                        />

                        {/* Catch all - redirect to home */}
                        <Route path="*" element={<Navigate to="/" replace />} />
                      </Routes>
                    </Layout>
                  </ProtectedRoute>
                }
              />
            </Routes>
          </Router>
        </ToastProvider>
      </AppProvider>
    </AuthProvider>
  );
}

export default App;
